<template>
  <b-row>
    <b-col md="12">
      <b-card v-if="$route.params.id">
        <b-row class="align-items-center">
          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">{{$t('application_number')}}</h6>
              <small>#{{ GET_APPLICATIONS_MATERIAL_ID.id ? GET_APPLICATIONS_MATERIAL_ID.id : '' }}</small>
            </div>
          </b-col>

          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">{{$t('date')}}</h6>
              <small>{{ $dayjs(GET_APPLICATIONS_MATERIAL_ID.created_at).format("DD.MM.YYYY") }}</small>
            </div>
          </b-col>

          <b-col class="col-md-2">
            <div class="flex_column">
              <h6 class="mb-50 font-weight-bolder">{{$t('author')}}</h6>
              <div class="d-flex">
                <small v-if="GET_APPLICATIONS_MATERIAL_ID.author">{{
                  GET_APPLICATIONS_MATERIAL_ID.author.first_name
                }}</small>
                <small
                  v-if="GET_APPLICATIONS_MATERIAL_ID.author"
                  class="ml-50"
                  >{{ GET_APPLICATIONS_MATERIAL_ID.author.last_name }}</small
                >
              </div>
            </div>
          </b-col>

          <b-col class="col-md-3">
            <div class="flex_column align-items-center">
              <h6 class="font-weight-bolder">{{$t('status')}}</h6>
              <b-badge
                v-if="GET_APPLICATIONS_MATERIAL_ID.status"
                :variant="GET_APPLICATIONS_MATERIAL_ID.status.color"
              >
                {{ GET_APPLICATIONS_MATERIAL_ID.status.name }}
              </b-badge>
            </div>
          </b-col>
          <b-col v-if="GET_APPLICATIONS_MATERIAL_ID.status" class="col-md-3">
            <div
              class="d-flex flex-wrap justify-content-end align-items-center"
            >
              <template
                v-for="(item, index) in GET_APPLICATIONS_MATERIAL_ID.status.change_to"
              >
                <b-button
                  :key="index"
                  v-if="checkButtonPermission([...item.roles, 'admin']) && checkAndHideStatusIfNeeded(item)"
                  size="sm"
                  class="ml-50"
                  style="margin: 3px 0"
                  :variant="item.color"
                  :disabled="checkAndDisableStatusIfNeeded(item)"
                  @click="onChangeStatus(GET_APPLICATIONS_MATERIAL_ID, item)"
                >
                  {{ item.name }}
                </b-button>
              </template>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <b-col cols="9">
      <b-card>
        <b-tabs>
          <b-tab active :title="$t('applications')">
            <div class="d-flex flex-wrap">
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  pb-50
                  w-100
                "
              >
                <h6 class="mb-0 font-weight-bolder">{{$t('reference.material')}}</h6>
                <div>
                  <!-- :disabled="checkWriteOffAction()" -->
                  <b-button
                    variant="primary"
                    size="sm"
                    class="ml-50"
                    @click="openWriteOffModal()"
                    v-if="
                      GET_APPLICATIONS_MATERIAL_ID &&
                      GET_APPLICATIONS_MATERIAL_ID.status &&
                      GET_APPLICATIONS_MATERIAL_ID.status.unique_name &&
                      (GET_APPLICATIONS_MATERIAL_ID.status.unique_name ==
                        'in_consideration' || 'purchase') &&
                      checkButtonPermission(['manager', 'admin'])
                    "
                  >
                    {{$t('create_write-off')}}
                  </b-button>
                  <!-- :disabled="checkMovementAction()" -->
                  <b-button
                    v-if="
                      GET_APPLICATIONS_MATERIAL_ID &&
                      GET_APPLICATIONS_MATERIAL_ID.status &&
                      GET_APPLICATIONS_MATERIAL_ID.status.unique_name &&
                      (GET_APPLICATIONS_MATERIAL_ID.status.unique_name ==
                       'in_consideration_on_main' || 'purchase') &&
                      (checkButtonPermission(['chief_manager', 'admin']))
                    "
                    variant="primary"
                    size="sm"
                    class="ml-50"
                    @click="openMovementModal()"
                  >
                    {{$t('create_move')}}
                  </b-button>
                </div>
              </div>

              <b-table
                class="table-bordered border"
                :fields="fields"
                :items="GET_APPLICATIONS_MATERIAL_ID.objects"
                show-empty
                hover
                responsive
                :empty-text="$t('empty_text')"
              >
                <template #row-details="row">
                  <span v-if="row.item && row.item.responsible">
                    {{$t('contact.comment')}}: {{ row.item.responsible }}
                  </span>
                </template>

                <template #head()="props">
                  <span>{{ $t(props.label) }}</span>
                </template>

                <template #cell(index)="{ index }">
                  <span>{{ index + 1 }}</span>
                </template>

                <template #cell(brigade)="props">
                  <span v-if="props && props.item && props.item.brigade">{{ props.item.brigade.title }}</span>
                </template>

                <template #cell(good)="props">
                  <span>{{ props.item.good.value }}</span>
                </template>

                <template #cell(start_count)="{ value }">
                  {{ $_formatPriceMixin(value) }}
                </template>

                <template #cell(count)="{ value, index }">
                  <div :class="'draw_color' + index">
                    {{ $_formatPriceMixin(value) }}
                  </div>
                </template>

                <template #cell(remainder)="{ value }">
                  {{ $_formatPriceMixin(value) }}
                </template>

                <template #cell(actions)="props">

                  <b-button size="sm" @click="props.toggleDetails" class="mr-2 mt-50 mb-50">
                    {{ props.detailsShowing ? $t('general.close') : $t('general.show') }}
                    {{$t('contact.comment2')}}
                  </b-button>

                  <b-button size="sm" @click="openContractsUsedModal(props.item)" class="mr-2 mt-50 mb-50" variant="info">
                    {{$t('show_contracts')}}
                  </b-button>
                  
                </template>
              </b-table>

              <div
                class="
                  mt-2
                  mb-2
                  d-flex
                  justify-content-between
                  align-items-center
                "
              >
                <div class="d-flex">
                  <h6 class="mb-0 font-weight-bolder">{{$t('sidebar.warehouse')}}:</h6>
                  <small
                    v-if="GET_APPLICATIONS_MATERIAL_ID &&
                     GET_APPLICATIONS_MATERIAL_ID.storage && 
                     GET_APPLICATIONS_MATERIAL_ID.storage.title"
                    class="ml-50"
                  >
                    {{ GET_APPLICATIONS_MATERIAL_ID.storage.title }}
                  </small>
                </div>
              </div>
            </div>
          </b-tab>

          <b-tab :title="$t('write-offs2')">
            <div class="d-flex flex-wrap">
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  pb-50
                  w-100
                "
              >
                <h6 class="mb-0 font-weight-bolder">{{$t('reference.material')}}</h6>
                <div>
                  <b-button
                    v-if="
                      checkAcceptWriteOff() &&
                      checkButtonPermission(['builder', 'admin'])
                    "
                    variant="success"
                    size="sm"
                    class="ml-50"
                    @click="openAcceptWriteOffModal()"
                  >
                    {{$t('accept')}}
                  </b-button>
                </div>
              </div>

              <app-collapse class="w-100" type="border">
                <app-collapse-item
                  :title="$t('write-off') + ' #' + item1.id"
                  v-for="(
                    item1, index1
                  ) in GET_APPLICATIONS_MATERIAL_ID.write_off"
                  :key="index1"
                >
                  <b-table
                    class="table-bordered border"
                    :fields="fields2"
                    :items="item1.objects"
                    show-empty
                    hover
                    responsive
                    :empty-text="$t('empty_text')"
                  >
                    <template #head()="props">
                      <span>{{ $t(props.label) }}</span>
                    </template>

                    <template #cell(quantity)="props">
                      <span>{{ $_formatPriceMixin(props.item.quantity) }}</span>
                    </template>

                    <template #cell(index)="{ index }">
                      <span>{{ index + 1 }}</span>
                    </template>
                  </b-table>
                </app-collapse-item>
              </app-collapse>

              <div
                class="
                  mt-2
                  mb-2
                  d-flex
                  justify-content-between
                  align-items-center
                "
              >
                <div class="d-flex">
                  <h6 class="mb-0 font-weight-bolder">{{$t('sidebar.warehouse')}}:</h6>
                  <small
                    v-if="GET_APPLICATIONS_MATERIAL_ID && 
                    GET_APPLICATIONS_MATERIAL_ID.storage &&
                     GET_APPLICATIONS_MATERIAL_ID.storage.title"
                    class="ml-50"
                  >
                    {{ GET_APPLICATIONS_MATERIAL_ID.storage.title }}
                  </small>
                </div>
              </div>
            </div>
          </b-tab>

          <b-tab :title="$t('movements')">
            <div class="d-flex flex-wrap">
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  pb-50
                  w-100
                "
              >
                <h6 class="mb-0 font-weight-bolder">{{$t('reference.material')}}</h6>
              </div>

              <app-collapse class="w-100" type="border">
                <template   v-for="(item1, index1) in GET_APPLICATIONS_MATERIAL_ID.movement">
                  <app-collapse-item
                    v-if="item1 && item1.from_storage && item1.from_storage.title"
                    :title="
                      '#' +
                      item1.id +
                      ' ' + $t('transfer_from_warehouse') + ' ' +
                      item1.from_storage.title
                    "
                    :key="index1"
                  >
                    <div class="d-flex justify-content-end mb-1">
                      <b-button
                        v-if="
                          item1.on_road &&
                          checkButtonPermission(['manager', 'admin'])
                        "
                        variant="success"
                        size="sm"
                        class="ml-50"
                        @click="onChangeMovementStatus(item1)"
                      >
                        {{$t('accept')}}
                      </b-button>

                      <div 
                        v-if="item1.status" class="d-flex flex-wrap justify-content-end align-items-center"
                      >
                        <template
                          v-for="(item2, index) in item1.status.change_to"
                        >
                          <b-button
                            :key="index"
                            v-if="checkButtonPermission([...item2.roles, 'admin'])"
                            size="sm"
                            class="ml-50"
                            style="margin: 3px 0"
                            :variant="item2.color"
                            @click="onChangeMovementStatus(item2, item1)"
                          >
                            <!-- :disabled="checkAndDisableStatusIfNeeded(item2)" -->
                            {{ item2.name }}
                          </b-button>
                        </template>
                      </div>
                    </div>

                              
                    <b-table
                      class="table-bordered border"
                      :fields="fields3"
                      :items="item1.objects"
                      show-empty
                      hover
                      responsive
                      :empty-text="$t('empty_text')"
                    >
                      <template #head()="props">
                        <span>{{ $t(props.label) }}</span>
                      </template>

                      <template #cell(category)="props">
                        {{ props.item && props.item.good && props.item.good.product &&
                         props.item.good.product.category && props.item.good.product.category.title ? props.item.good.product.category.title : '' }}
                      </template>
                   
                      <template #cell(product)="props">
                        {{ props.item && props.item.good && props.item.good.product && 
                        props.item.good.product.title ? props.item.good.product.title : '' }}
                      </template>
                      
                      <template #cell(count)="{ value }">
                        {{ $_formatPriceMixin(value) }}
                      </template>

                      <template #cell(remainder)="{ value }">
                        {{ $_formatPriceMixin(value) }}
                      </template>

                      <template #cell(index)="{ index }">
                        <span>{{ index + 1 }}</span>
                      </template>
                    </b-table>
                  </app-collapse-item>
                </template>
              </app-collapse>

              <div
                class="
                  mt-2
                  mb-2
                  d-flex
                  justify-content-between
                  align-items-center
                "
              >
                <div class="d-flex">
                  <h6 class="mb-0 font-weight-bolder">{{$t('sidebar.warehouse')}}:</h6>
                  <small
                    v-if="GET_APPLICATIONS_MATERIAL_ID
                    && GET_APPLICATIONS_MATERIAL_ID.storage
                    && GET_APPLICATIONS_MATERIAL_ID.storage.title"
                    class="ml-50"
                  >
                    {{ GET_APPLICATIONS_MATERIAL_ID.storage.title }}
                  </small>
                </div>
              </div>

            


            </div>
          </b-tab>
        </b-tabs>

      </b-card>





      <div class="text-right ">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="d-flex align-items-center"
          variant="secondary"
          @click="$router.back()"
        >
          <feather-icon icon="ArrowLeftIcon" size="18" />
          {{ $t("back") }}
        </b-button>
      </div>






    </b-col>
    <b-col cols="3">
      <b-card>
        <div class="d-flex flex-wrap">
          <app-timeline class="h-100 w-100">
            <app-timeline-item
              v-for="item in GET_APPLICATION_STATUS_TIMELINE_BY_ID"
              :key="item.id"
              :title="item.to_status.full_name + ' #' + item.object_id"
              :subtitle="item.author.first_name + ' ' + item.author.last_name"
              :comment="(item.description ? item.description : '')"
              :icon="item.to_status.icon"
              :time="$dayjs(item.created_at).format('DD.MM.YYYY, HH:mm')"
              :variant="item.to_status.color"
              :author="true"
            />
          </app-timeline>
        </div>
      </b-card>
    </b-col>

    <writeOffModal @refreshCall="refreshCall($event)"></writeOffModal>
    <acceptWriteOffModal
      @refreshCall="refreshCall($event)"
    ></acceptWriteOffModal>
    <movementModal @refreshCall="refreshCall($event)"></movementModal>

    <b-modal
      ref="confirmOrRefuse"
      cancel-variant="outline-secondary"
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      centered
      size="md"
      no-close-on-backdrop
      :title="$t('do_you_really_want') + ' ' + $t('refuse_this_application')"
      @ok="onStatusChangedAndSaved($event)"
    >
      <div>
        <validation-observer ref="confirmOrRefuseObserver">
          <b-form-group :label="$t('contact.comment')">
            <validation-provider
              #default="{ errors }"
              :name="$t('contact.comment')"
              rules="required"
            >
              <b-form-textarea
                v-model="statusComment"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </div>
    </b-modal>

    <seeProductsModal :seeProducts="seeProducts"></seeProductsModal>

  </b-row>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCol,
  BRow,
  BTable,
  VBTooltip,
  BTabs,
  BTab,
  BFormGroup,
  BFormInput,
  BFormTextarea,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";

import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";

import writeOffModal from "./components/modals/writeOffModal.vue";
import acceptWriteOffModal from "./components/modals/acceptWriteOffModal.vue";
import movementModal from "./components/modals/movementModal.vue";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import { getUserData } from "@/auth/utils";
import check from "@/mixins/check";
import loader from "@/mixins/loader";
import Ripple from "vue-ripple-directive";
import seeProductsModal from './components/modals/seeProductsModal.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BButton,
    BCard,
    BBadge,
    BTabs,
    BTab,
    BFormGroup,
    BFormInput,
    BFormTextarea,

    AppTimeline,
    AppTimelineItem,

    AppCollapse,
    AppCollapseItem,

    writeOffModal,
    acceptWriteOffModal,
    movementModal,
    seeProductsModal,

    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  mixins: [priceFormatMixin, check, loader],
  data() {
    return {
      // ===============  PRIMARY_DATA_SECTION START ===============
      movement: {
        goods: [],
        requirement: "",
      },
      userData: {},
      statusComment: '',
      statusDeniedOrWaiting: '',
      seeProducts: [],
      fields: [
        {
          label: "№",
          key: "index",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "brigade",
          key: "brigade",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "reference.categoriya",
          key: "good.product.category.title",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "courses.type",
          key: "good.product.title",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "namee",
          key: "good",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "reference.units",
          key: "good.unity",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "starting_quantity",
          key: "start_count",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "amount",
          key: "count",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "remaining_stock",
          key: "remainder",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { width: "5%" },
        },
      ],
      fields2: [
        {
          label: "№",
          key: "index",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "courses.type",
          key: "product",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "namee",
          key: "good",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "amount",
          key: "quantity",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      fields3: [
        {
          label: "№",
          key: "index",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "reference.categoriya",
          key: "category",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "courses.type",
          key: "product",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "namee",
          key: "good.value",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "reference.units",
          key: "good.unity",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "amount",
          key: "count",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "remaining_stock",
          key: "remainder",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      // ===============  PRIMARY_DATA_SECTION END ===============
    };
  },
  computed: {
    ...mapGetters("application", [
      "GET_APPLICATIONS_MATERIAL_ID",
      "GET_APPLICATION_STATUS_TIMELINE_BY_ID",
    ]),
    refreshViewMaterial: {
      get: function () {
        return this.$store.state.agrements.refreshViewMaterial;
      },
      set: function (newValue) {
        this.$store.commit('application/SET_REFRESH_VIEW_MATERIAL', newValue)
      }
    },
  },
  watch: {
    async refreshViewMaterial(newValue){
      if(newValue){
        await this.refresh();
      }
    }
  },
  async mounted() {
    // await this.$_loaderStart();
    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.refresh();
    // ===============  PRIMARY_REQUESTS_SECTION END ===============

    this.userData = getUserData();
  },
  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },
  methods: {
    ...mapActions("application", [
      "FETCH_APPLICATIONS_MATERIAL_ID",
      "UPDATE_APPLICATION_MATERIAL",
      "UPDATE_PATCH_APPLICATION_MATERIAL",
      "UPDATE_APPLICATION_MATERIAL_MOVEMENT",
      "FETCH_APPLICATION_STATUS_TIMELINE_BY_ID",
    ]),









    // ===============  OPEN_MODAL_SECTION START ===============
    openAcceptWriteOffModal() {
      this.$bvModal.show("modal-accept-write-off-material");
    },
    openWriteOffModal() {
      this.$bvModal.show("modal-write-off-material");
    },
    openMovementModal() {
      if(this.GET_APPLICATIONS_MATERIAL_ID.status.unique_name != 'in_consideration_on_main' && this.GET_APPLICATIONS_MATERIAL_ID.status.unique_name  != 'purchase'
      && this.GET_APPLICATIONS_MATERIAL_ID.status.unique_name  != 'material_is_on_main_store'){
        this.$_warningToast(this.$t('you_are_not_in_needed_status'))
      }else{
        this.$bvModal.show("modal-movement-material");
      }
    },
    openContractsUsedModal(item){
      this.seeProducts = item.contracts
      this.$bvModal.show('seeProductsModal')
    },
    // ===============  OPEN_MODAL_SECTION START ===============












    // ===============  REFRESH_SECTION START ===============
    async refreshCall(value) {
      if (value) {
        await this.refresh();
      }
    },
    async refresh() {
      await this.FETCH_APPLICATIONS_MATERIAL_ID({id: this.$route.params.id, params: {show_archive: 1, show_purchase: 1}})
        .then(async () => {
          
          this.GET_APPLICATIONS_MATERIAL_ID.objects.forEach((elem, index) => {
            if(elem.count == elem.start_count){
              const button = document.querySelector('.draw_color' + index);
              const div = button.parentNode;
              div.classList.remove("bg-success");
              div.classList.remove("bg-warning");
              div.classList.add("bg-danger");
              div.classList.add("text-white");
            }else if(elem.count == 0){
              const button = document.querySelector('.draw_color' + index);
              const div = button.parentNode;
              div.classList.remove("bg-danger");
              div.classList.remove("bg-warning");
              div.classList.add("bg-success");
              div.classList.add("text-white");
            }else if(elem.count < elem.start_count){
              const button = document.querySelector('.draw_color' + index);
              const div = button.parentNode;
              div.classList.remove("bg-danger");
              div.classList.remove("bg-success");
              div.classList.add("bg-warning");
              div.classList.add("text-white");
            }
          })


          await this.FETCH_APPLICATION_STATUS_TIMELINE_BY_ID({
            id: this.$route.params.id,
            params: {
              content_type_model: "requirements",
              object_id: this.$route.params.id,
            },
          });
        })
        .catch((err) => {
          if (
            err &&
            err.response &&
            err.response.status &&
            err.response.status == 404
          ) {
            this.$router.push("/applications/material");
          }
        });
    },
    // ===============  REFRESH_SECTION START ===============














    // ===============  CHECK_AND_DISABLE_SECTION START ===============
    checkAndDisableStatusIfNeeded(item) {
      if (item.unique_name == "closed") {
        let status = false;
        this.GET_APPLICATIONS_MATERIAL_ID.objects.forEach((elem) => {
          if (elem.count > 0) {
            status = true;
          }
        });
        return status;
      } else if (item.unique_name == "in_consideration_on_main") {
        let status = true;
        this.GET_APPLICATIONS_MATERIAL_ID.objects.forEach((elem) => {
          if (elem.remainder < elem.count) {
            status = false;
          }
        });
        return status;
      } else if (item.unique_name == "denied") {
        if (
         this.GET_APPLICATIONS_MATERIAL_ID.write_off &&
         this.GET_APPLICATIONS_MATERIAL_ID.write_off.length == 0 &&
         this.GET_APPLICATIONS_MATERIAL_ID.status.unique_name == "in_consideration"
         || this.GET_APPLICATIONS_MATERIAL_ID.status.unique_name == "in_consideration_foreman"
         || this.GET_APPLICATIONS_MATERIAL_ID.status.unique_name == "purchase"
        ) {
          return false;
        } else {
          return true;
        }
      } 

      // else if (item.unique_name == "purchase") {
      //   if (
      //     this.GET_APPLICATIONS_MATERIAL_ID.objects.length != 0 &&
      //     this.checkMovements()
      //   ) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // }



    },
    checkAndHideStatusIfNeeded(item){
      let status = false
      if(item && item.unique_name && item.unique_name == 'denied'){
        if(this.GET_APPLICATIONS_MATERIAL_ID && this.GET_APPLICATIONS_MATERIAL_ID.write_off && this.GET_APPLICATIONS_MATERIAL_ID.write_off.length == 0 && 
        this.GET_APPLICATIONS_MATERIAL_ID.movement && this.GET_APPLICATIONS_MATERIAL_ID.movement.length == 0){

          this.GET_APPLICATIONS_MATERIAL_ID.objects.forEach((elem) => {
            if(elem.contracts && elem.contracts.length == 0 && !status){
              status = true
            }else{
              status = false
            }
          })
        }
      }else{
        status = true
      }
      return status
    },
    checkMovements() {
      let a = true;
      if (
        this.GET_APPLICATIONS_MATERIAL_ID &&
        this.GET_APPLICATIONS_MATERIAL_ID.objects
      ) {
        this.GET_APPLICATIONS_MATERIAL_ID.objects.forEach((elem) => {
          if (elem.count > elem.remainder) {
            a = false;
          }
        });
      }
      return a;
    },
    checkWriteOffAction() {
      let a = false;
      if (
        this.GET_APPLICATIONS_MATERIAL_ID &&
        this.GET_APPLICATIONS_MATERIAL_ID.objects
      ) {
        this.GET_APPLICATIONS_MATERIAL_ID.objects.find((elem) => {
          if (elem.count <= elem.remainder) {
            a = false;
          } else {
            a = true;
          }
        });
      }
      return a;
    },
    checkAcceptWriteOff() {
      let a = false;
      if (
        this.GET_APPLICATIONS_MATERIAL_ID &&
        this.GET_APPLICATIONS_MATERIAL_ID.write_off
      ) {
        this.GET_APPLICATIONS_MATERIAL_ID.write_off.forEach((elem) => {
          if (elem.is_new == true) {
            a = true;
          }
        });
      }
      return a;
    },
    // ===============  CHECK_AND_DISABLE_SECTION START ===============







    // ===============  ON_CHANGE_STATUS_SECTION START ===============
    onChangeStatus(props, item) {
      const status = {
        in_consideration: this.$t('submit_this_application_for_review'),
        in_consideration_foreman: this.$t('submit_this_application_for_review_on_foreman'),
        in_consideration_on_main: this.$t('submit_this_application_for_review_at_the_main_warehouse'),
        confirmed: this.$t('confirm_this_application'),
        denied: this.$t('refuse_this_application'),
        purchase: this.$t('create_a_purchase_requisition'),
        closed: this.$t('close2'),

        accept_movement: this.$t("accepted"),
        on_way_movement: this.$t("send_on_the_way"),
      };


      this.statusId = props.id
      if(item.unique_name == 'denied'){
        this.$refs['confirmOrRefuse'].show()
        this.statusDeniedOrWaiting = 'denied'
      }else{
        this.$bvModal
          .msgBoxConfirm(
            this.$t('do_you_really_want') + ` ${status[item.unique_name]} ?`,
            {
              title: this.$i18n.t('attention'),
              size: "sm",
              okVariant: item.color,
              okTitle: this.$t('yes'),
              cancelTitle: this.$t('no'),
              cancelVariant: "outline-secondary",
              hideHeaderClose: false,
              centered: true,
            }
          )
          .then(async (value) => {
            if (!value) return;
            await this.UPDATE_PATCH_APPLICATION_MATERIAL({
              status_unique: item.unique_name,
              id: props.id,
            }).then(async () => {
              await this.refresh();
            });
          });
      }
    },
    async onStatusChangedAndSaved(bvModalEvt){
      bvModalEvt.preventDefault();
      await this.$refs.confirmOrRefuseObserver.validate().then(async (success) => {
        if (!success) return;
        await this.UPDATE_PATCH_APPLICATION_MATERIAL({
          status_unique: this.statusDeniedOrWaiting,
          status_description: this.statusComment,
          id: this.statusId,
        }).then(() => {
          this.refresh();
          this.$_okToast("success");
          this.$refs.confirmOrRefuse.hide()
        });
      })
    },
    onChangeMovementStatus(item, props) {
      const status = {
        accept_movement: this.$t('accept_materials'),
      };
      this.$bvModal
        .msgBoxConfirm(this.$t('do_you_really_want') + ` ${status.accept_movement} ?`, {
          title: this.$i18n.t('attention'),
          size: "sm",
          okVariant: item.color,
          okTitle: this.$t('yes'),
          cancelTitle: this.$t('no'),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (!value) return;

          let id = null
          if(props){
            id = props.id
          }else{
            id = item.id
          }
          
          let unique_name = null
          if(props){
            unique_name = item.unique_name
          }else{
            unique_name = 'accept_movement'
          }
          await this.UPDATE_APPLICATION_MATERIAL_MOVEMENT({
            status_unique: unique_name,
            id: id,
          })
            .then(async () => {
              await this.refresh();
              this.$_okToast("success");
            })
            .catch((err) => {
              console.log(err);
            });
        });
    },
    // ===============  ON_CHANGE_STATUS_SECTION END ===============
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.flex_column {
  display: flex;
  flex-direction: column;
}
</style>
